import { render, staticRenderFns } from "./OtherCostListDetail.vue?vue&type=template&id=5ee4959d&scoped=true&"
import script from "./OtherCostListDetail.vue?vue&type=script&lang=js&"
export * from "./OtherCostListDetail.vue?vue&type=script&lang=js&"
import style0 from "./OtherCostListDetail.vue?vue&type=style&index=0&id=5ee4959d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee4959d",
  null
  
)

export default component.exports